import { showSidebar } from '@components/sidebar';

import { getJourneyActionQueryKey } from 'api/journey-actions/hooks';
import { queryClient } from 'api/query-client';
import { SidebarContent as addToJourney } from 'ui/actions/add-to-journey/journey-sidebar';
import { SidebarContent as anonymizeText } from 'ui/actions/anonymize-text/journey-sidebar';
import { SidebarContent as askAIAgent } from 'ui/actions/ask-ai-agent/journey-sidebar';
import { SidebarContent as askAI } from 'ui/actions/ask-ai/journey-sidebar';
import { SidebarContent as branch } from 'ui/actions/branch/journey-sidebar';
import { SidebarContent as breakLoop } from 'ui/actions/break-loop/journey-sidebar';
import { SidebarContent as calendarEvent } from 'ui/actions/calendar-event/journey-sidebar';
import { SidebarContent as code } from 'ui/actions/code/journey-sidebar';
import { SidebarContent as comboSendForm } from 'ui/actions/combo-send-form/journey-sidebar';
import { SidebarContent as condition_v2 } from 'ui/actions/condition-v2/journey-sidebar';
import { SidebarContent as condition } from 'ui/actions/condition/journey-sidebar';
import { SidebarContent as convertDocument } from 'ui/actions/convert-document/journey-sidebar';
import { SidebarContent as createDocument } from 'ui/actions/create-document/journey-sidebar';
import { SidebarContent as extractText } from 'ui/actions/extract-text/journey-sidebar';
import { SidebarContent as formatter } from 'ui/actions/formatter/journey-sidebar';
import { SidebarContent as integration } from 'ui/actions/integration/journey-sidebar';
import { SidebarContent as loop } from 'ui/actions/loop/journey-sidebar';
import { SidebarContent as merge } from 'ui/actions/merge/journey-sidebar';
import { SidebarContent as placeholder } from 'ui/actions/placeholder/journey-sidebar';
import { SidebarContent as sendEmail } from 'ui/actions/send-email/journey-sidebar';
import { SidebarContent as sendSms } from 'ui/actions/send-sms/journey-sidebar';
import { SidebarContent as updateFields } from 'ui/actions/update-fields/journey-sidebar';
import { SidebarContent as updateTraveller } from 'ui/actions/update-traveller/journey-sidebar';
import { SidebarContent as waitForAttributeChange } from 'ui/actions/wait-for-attribute-change/journey-sidebar';
import { SidebarContent as waitFor } from 'ui/actions/wait-for/journey-sidebar';
import { SidebarContent as waitUntilFixed } from 'ui/actions/wait-until-fixed/journey-sidebar';
import { SidebarContent as waitUntilRelative } from 'ui/actions/wait-until-relative/journey-sidebar';
import { SidebarContent as webhook } from 'ui/actions/webhook/journey-sidebar';

import { JourneyNodeBase } from './node-types/types';
import { setContinueRegistry } from './unsaved-changes-prompt';

export const sidebarContentMap = {
  placeholder,
  break_loop: breakLoop,
  journey_loop: loop,
  code,
  condition,
  condition_v2,
  convert_document: convertDocument,
  create_document: createDocument,
  calendar_event: calendarEvent,
  combo_send_form: comboSendForm,
  integration,
  webhook,
  wait_for_time: waitFor,
  wait_for_attribute_change: waitForAttributeChange,
  wait_until_relative_date: waitUntilRelative,
  wait_until_fixed_date: waitUntilFixed,
  send_sms: sendSms,
  send_email: sendEmail,
  journey_branch: branch,
  journey_merge: merge,
  formatter,
  ask_ai: askAI,
  ask_ai_agent: askAIAgent,
  update_fields: updateFields,
  add_to_journey: addToJourney,
  update_traveller: updateTraveller,
  anonymize_text: anonymizeText,
  extract_text: extractText,
};

export const showActionSidebar = (node: JourneyNodeBase, options?: { isNewAction?: boolean }) => {
  const hasSidebar = node.type in sidebarContentMap;
  if (hasSidebar) {
    const SidebarComponent = sidebarContentMap[node.type as keyof typeof sidebarContentMap];
    setContinueRegistry({ onContinue: () => showActionSidebar(node), id: node.id });
    queryClient.removeQueries(getJourneyActionQueryKey(node.id));
    showSidebar({
      component: SidebarComponent,
      options: {
        variant: 'REGULAR',
        id: node.id,
        onHide: () =>
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey[0] === 'journey' && query.queryKey[1] !== 'action',
          }),
      },
      props: { journeyActionId: node.id, ...(options?.isNewAction ? { isNewAction: true } : {}) },
    });
  }
};
